import { useQuery } from '@tanstack/react-query'
import { getCurrentUser } from '../lib/auth-client'
import { queries } from '../lib/queries'
import { STALE_TIMES } from '../lib/query-config'

export function useCurrentUser(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queries.auth.currentUser(),
    queryFn: getCurrentUser,
    enabled: options?.enabled !== false,
    staleTime: STALE_TIMES.auth,
    refetchOnWindowFocus: true,
    retry: 1,
  })
}
